<template>
  <div class="login">
    <div class="username">
      <div id="title">
        <strong>账号登录</strong>
      </div>
      <el-form
        :model="loginform"
        ref="ruleForm"
        :rules="rules"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="username">
          <el-input
            prefix-icon="el-icon-user"
            placeholder="email"
            v-model="loginform.username"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-row :gutter="8">
            <el-col :span="16">
              <el-input
                prefix-icon="el-icon-lock"
                v-model="loginform.password"
                placeholder="验证码"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <el-button
                type="primary"
                plain
                @click.prevent="sendValidationCode()"
                >发送验证码</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%"
            @click.prevent="submitForm('ruleForm')"
            >登录/注册</el-button
          >
          <!-- <el-button type="primary" style="width:100%" @click="test()">test</el-button> -->
        </el-form-item>
      </el-form>
      <!-- <div class="region">
        <el-link @click="goRegister()">注册新用户</el-link>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-link @click="goRegister()">找回密码</el-link>
      </div> -->
    </div>
    <div class="footer">hello, welcome!</div>
  </div>
</template>

<script>
import { getCurrentInstance, reactive, ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

export default {
  name: "Login",

  // 接收父组件的事件
  emits: ["is-show"],

  setup(props, context) {
    const clientId = "pengyou-client";
    const clientPassword = "111111";
    const baseURL = "http://localhost:9000";
    const { proxy } = getCurrentInstance();
    let currentPath = "";

    const ruleForm = ref(null);
    const loginform = reactive({
      username: "",
      password: "",
      registration_id: "",
      validate_code: "",
    });

    const checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (value === "") {
        callback(new Error("请输入用户名"));
      }
      if (!mailReg.test(value)) {
        callback(new Error("用户名必须为邮箱格式"));
      }
      callback();
    };

    let rules = reactive({
      username: [{ validator: checkEmail, trigger: "blur" }],
      password: [
        {
          required: true,
          message: "请输入正确的数字验证码",
          trigger: "blur",
        },
      ],
    });

    function sendValidationCode() {
      if (loginform.username === "") {
        ElMessage.error("请输入邮件地地址");
      }
      console.log(loginform.username);
      proxy.$http
        .post(
          "/validationCode/send?user=" + loginform.username,
          {},
          {
            baseURL: baseURL,
          }
        )
        .then((response) => {
          console.log(response);
          // ElMessage.success("验证码发送成功");
          // TODO 设置token 1个月有效期
          // TODO 记住用户名
          loginform.registration_id = response;
          proxy.$cookie.set("registrationId", loginform.registration_id, {
            expires: "1M",
          });
        });
    }

    const $router = useRouter();
    onMounted(() => {
      //当前路由路径名称
      currentPath = $router.currentRoute._rawValue.path;
      // 对用户名赋值
      console.log(proxy.$cookie.get("username"));
      if (
        typeof proxy.$cookie.get("username") != undefined &&
        proxy.$cookie.get("username") != null
      ) {
        loginform.username = proxy.$cookie.get("username");
      }
    });

    function submitForm(formName) {
      console.log(loginform.username);
      console.log(props);
      console.log(context);
      // console.log(root);

      console.log(formName);
      ruleForm.value.validate((valid) => {
        if (valid) {
          console.log("aaassssss");
          const userBase64 = btoa(`${clientId}:${clientPassword}`);
          if (
            loginform.registration_id === "" &&
            typeof proxy.$cookie.get("registrationId") != "undefined"
          ) {
            loginform.registration_id = proxy.$cookie.get("registrationId");
          }
          if (
            loginform.registration_id == null ||
            typeof loginform.registration_id == "undefined" ||
            loginform.registration_id == "undefined"
          ) {
            ElMessage.error("请先获取验证码");
            return;
          }
          proxy.$http
            .post(
              "/oauth2/token?grant_type=password&username=" +
                loginform.username +
                "&registration_id=" +
                loginform.registration_id +
                "&validation_code=" +
                loginform.password,
              {},
              {
                headers: {
                  Authorization: `Basic ${userBase64}`,
                },
                baseURL: baseURL,
              }
            )
            .then((response) => {
              if (response == null) {
                return;
              }
              console.log("aaaa" + response);

              proxy.$cookie.set("accessToken", response.accessToken, {
                expires: "1M",
              });
              proxy.$cookie.set("username", loginform.username, {
                expires: "1M",
              });
              // proxy.$router.push("/login");
              proxy.$router.push("/solution");
              if (currentPath.indexOf("login") < 0) {
                // proxy.$router.go(0);
                context.emit('is-show')
              }
              console.log(proxy.$cookie.get("accessToken"));
              return;
            })
            .catch((err) => {
              console.log("登陆失败");
              console.log(err);
              // if (err.response.status === 401) {
              //   proxy.$message({
              //     message: "用户名或者密码错误",
              //     type: "error",
              //   });
              // }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
    // function resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // }
    // function test() {
    //   //console.log(this.$cookies.get("Path"));
    //   console.log(atob("d2FuZ2h1aXhpb25nOndhbmdodWl4aW9uZw=="));
    // }
    // function goRegister() {
    //   this.$router.push("/register");
    // }
    return { loginform, rules, ruleForm, submitForm, sendValidationCode };
  },
};
</script>
<style lang="scss" scoped>
.login {
  background-color: white;
  position: absolute;
  top: calc(50% - 250px);
  left: calc(50% - 200px);
  width: 400px;
  height: 480px;
  border: 1px solid $my-border-color;
  text-align: center;
  font-family: $my-font-family;
}
.username {
  padding: 50px 50px 160px 50px;
}
#title {
  height: 60px;
  color: #409eff;
  font-size: 20px;
}
.region {
  height: 40px;
}
.footer {
  background-color: $my-border-color;
  height: 58px;
  line-height: 60px;
}
</style>